import script from "./ShowTrainings.vue?vue&type=script&setup=true&lang=js"
export * from "./ShowTrainings.vue?vue&type=script&setup=true&lang=js"

import "./ShowTrainings.vue?vue&type=style&index=0&id=7d74eb85&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d74eb85"]])

export default __exports__